export default "/_next/static/chunks/fonts/Ubuntu-Regular-latin-c5b897a69ed47ee4a7705f38089a1977.woff2";